import React, { Component } from "react";
class ContainerRight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slider: [
        {
          id: 1,
          image: "./images/section/project2.png",
          alt: "website-image",
          to: "https://sdbrows.netlify.app/",
          to2: "https://github.com/sarauras1/new.sd",
        },

        {
          id: 2,
          image: "./images/projects/weather-app.png",
          alt: "weather-app-images",
          to: "https://stately-chimera-4597e3.netlify.app/",
          to2: "https://github.com/sarauras1/Weather-App",
        },
        {
          id: 3,
          image: "./images/projects/shop-image.png",
          alt: "shop-images",
          to: "https://incomparable-dolphin-c4acd7.netlify.app/shop",
          to2: "https://github.com/sarauras1/react-shop",
        },

        {
          id: 4,
          image: "./images/projects/memo-game.png",
          alt: "memo-game-images",
          to: "https://memorysaragame.netlify.app/",
          to2: "https://github.com/sarauras1/MemoryGame",
        },
         {
          id: 5,
          image: "./images/projects/rioxoris.png",
          alt: "rio-images",
          to: "https://www.rioxoris.it/",
          to2: "",
        },
      ],
    };
  }
  render() {
    return (
      <div
        className="col-right animate-element wow delay5 fadeInUp"
        data-wow-delay="0.5s"
      >
        <div
          className="flat-spacer"
          data-desktop="4"
          data-mobile="70"
          data-smobile="70"
        ></div>
        <div className="slider-drop-apps custom-dot dot-t2 dot-s2 number-pages none-nav-default mg-dots-s2">
          <div
            className="flat-carousel-box data-effect clearfix"
            data-gap="0"
            data-column="1"
            data-column2="1"
            data-column3="1"
            data-column4="1"
            data-column5="1"
            data-dots="true"
            data-auto="false"
            data-nav="false"
            data-loop="true"
          >
            <div className="owl-carousel">
              {this.state.slider.map((data) => (
                <div className="featured-post" key={data.id}>
                  <img src={data.image} alt={data.alt} />
                  <div className="buttons-flat">
                    <a className="flat-links" href={data.to}>
                      Go to website
                    </a>
                    <a className="flat-links" href={data.to2}>
                      View Code
                    </a>
                    {/* <a href="#Modal" className="flat-links open-modal">
                      Description
                    </a> */}
                  </div>
                </div>
              ))}
           
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContainerRight;
